import React from 'react';
import { Modal, Card, Row, Col, Form, Tag, Input, InputNumber, Radio, Popconfirm, Button, message, Tooltip, Icon, Spin, Select, Popover, Upload, Table, Checkbox } from "antd"
import { withRouter } from 'react-router-dom';
import { API, Auth, Storage } from "aws-amplify"
import moment from 'moment'
import InvoiceView from '../../Components/Invoices/InvoiceView'
import { connect } from "react-redux"
import { allState as mapStateToProps, allDispatch as mapDispatchToProps } from "../../Redux/Selectors"
import definitions from '../../Util/AFIPdefinitions'
import userStates from '../../Util/UserStates'

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
        message.error('Solo puedes subir imágenes en formato JPG/PNG!');
    }
    const isLt3M = file.size / 1024 / 1024 < 5;
    if (!isLt3M) {
        message.error('La imagen debe ser menor de 5MB!');
    }
    return isJpgOrPng && isLt3M;
}
//test
const { Option } = Select;
const { TextArea } = Input;

class EditUserForm extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            medioPago: '',
            motivoAnulacion: '',
            user: {},
            new_data: {
            },
            loading_user: true,
            invoiceView: false,
            dash_data: [],
            loading_dashboard: true,
            loading_iibb: true,
            pedir_fotos: true,
            loading_monotributo: true,
            editting: false,
            visible: false,
            loadingImage: false,
        };
        this.cancellPhotoRequest = this.cancellPhotoRequest.bind(this);
        this.cancellPhotoRequestAndSendEmail = this.cancellPhotoRequestAndSendEmail.bind(this);
    };

    onChange(image, idFoto) {
        this.setState({ loadingImage: true })
        Storage.put(this.state.user.email.toLowerCase() + '/' + idFoto, image, {
            level: 'public',
            contentType: 'image/jpg'
        })
            .then(result => {
                message.success("Foto Cargada con Exito")
                let usr = { ...this.state.user }
                usr[idFoto] = true
                this.setState({ user: usr, loadingImage: false })
                this.call_api(true)

            })
            .catch(err => {
                console.log(err)
                this.setState({ loadingImage: false })
            });

    }

    call_api = (foto) => {
        if (foto === true) {
            this.send_data()
        } else {
            this.props.form.validateFieldsAndScroll({ first: true }, (err, values) => {
                if (!err) {
                    this.send_data()
                }
            })
        }
    }

    getFactura(invoiceId) {
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/invoices/' + this.props.user_id + '/' + invoiceId,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        if (response === null) {
                            message.error('No se pudo leer la factura del usuario')
                        }
                        let i = 0
                        let items = response.items.map(item => {
                            item['key'] = i
                            i++
                            return item
                        })
                        this.setState({ factura: response, invoiceItems: items, invoiceView: true })
                    })
                    .catch(err => {
                        console.log(err)
                        this.props.history.push('/')
                    })
            })
    }

    downloadUrl(url, cuit, fecha_emision, nro_comprobante){
        var link = document.createElement("a")
        link.setAttribute('download', fecha_emision + "_" + cuit + "_" + nro_comprobante + ".pdf")
        link.href = url
        document.body.appendChild(link);
        link.click();
        link.remove();
      }

    downloadPdf(invoice, user, userId){
        let invoiceId = invoice.invoiceId

        this.setState({loading:true})
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/pdf/'+invoiceId,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                        queryStringParameters:{
                            userId:userId
                        }
    
                    }
                )
                    .then(response => {
                        this.setState({ loading: false})
                        var byteCharacters = atob(response['pdf']);
                        var byteNumbers = new Array(byteCharacters.length);
                        for (var i = 0; i < byteCharacters.length; i++) {
                          byteNumbers[i] = byteCharacters.charCodeAt(i);
                        }
                        var byteArray = new Uint8Array(byteNumbers);
                        var file = new Blob([byteArray], { type: 'application/pdf;base64' });
                        var fileURL = URL.createObjectURL(file);
                        
                        this.downloadUrl(fileURL, user.cuit, invoice.fecha, invoice.nroDeComprobante)
                    })
    
                    .catch(err => {
                        message.error('Error generando PDF')
                        this.setState({loading:false})
                        console.log(err)})
            })
    }

    send_motivo = () => {
        this.setState({ loading: true })
        Auth.currentSession()
            .then(session => {
                let body ={
                    nombre: this.state.user.nombre,
                    apellido: this.state.user.apellido,
                    razon_social: this.state.user.razon_social,
                    email: this.state.user.email,
                    telefono: this.state.user.telefono,
                    direccion: this.state.user.direccion,
                    ciudad: this.state.user.ciudad,
                    provincia: this.state.user.provincia,
                    cp: this.state.user.cp,
                    cuit: this.state.user.cuit,
                    clave_fiscal: this.state.user.clave_fiscal,
                    cur: this.state.user.cur,
                    inicio_actividad: this.state.user.inicio_actividad,
                    aportes_sipa: this.state.user.aportes_sipa,
                    os: this.state.user.os,
                    familiares_os: this.state.user.familiares_os,
                    cuit_empleador: this.state.user.cuit_empleador,
                    iibb: this.state.user.iibb,
                    iibb_numero: this.state.user.iibb_numero,
                    local_comercial: this.state.user.local_comercial,
                    costo_alquiler: this.state.user.costo_alquiler,
                    actividad_1: this.state.user.actividad_1,
                    actividad_2: this.state.user.actividad_2,
                    actividad_3: this.state.user.actividad_3,
                    estado_usuario: this.state.user.estado_usuario,
                    estado_clave_fiscal: this.state.user.estado_clave_fiscal,
                    estado_monotributo: this.state.user.estado_monotributo,
                    estado_pago: this.state.user.estado_pago,
                    plan: this.state.user.plan,
                    plan_id: this.state.user.plan_id,
                    fecha_inicio: this.state.user.fecha_inicio,
                    fecha_fin: this.state.user.fecha_fin,
                    fac_inicial_sem_actual: this.state.user.fac_inicial_sem_actual,
                    fac_inicial_sem_anterior: this.state.user.fac_inicial_sem_anterior,
                    punto_venta: this.state.user.punto_venta,
                    foto_dni_fr: this.state.user.foto_dni_fr,
                    foto_dni_tr: this.state.user.foto_dni_tr,
                    foto_rostro: this.state.user.foto_rostro,
                    tipo_actividad: this.state.user.tipo_actividad,
                    cat_monotributo: this.state.user.cat_monotributo,
                    tipo_responsable: this.state.user.tipo_responsable,
                }
                if(this.state.user.estado_usuario === "BAJA" || this.state.user.estado_monotributo === "HACER_BAJA"){
                    body["baja"]=this.state.user.estado_monotributo === "HACER_BAJA" ? true: false
                }
                API.put(
                    'test',
                    '/root/users/cancelPhotoAndSendEmail/' + this.props.user_id + '/' + this.state.motivoAnulacion,
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: body
                    }
                )
                .then(response => {
                    message.success("Usuario actualizado")
                    this.setState({ loading: false })
                })
                .catch(err => {
                    message.error("Error de actualización de usuario")
                    this.setState({ loading: false })
                })
            })
            .catch(err => {
                message.error("Error obteniendo credenciales de usuario")
                console.log(err)
            })
    }

    send_data = (sendEmail = false) => {
        this.setState({ loading: true })
        Auth.currentSession()
            .then(session => {
                let endpoint = '/root/users/' + this.props.user_id
                if (sendEmail) {
                    endpoint = '/root/users/cancelPhotoAndSendEmail/' + this.props.user_id + '/' + this.state.motivoAnulacion
                }
                let body ={
                    nombre: this.state.user.nombre,
                    apellido: this.state.user.apellido,
                    razon_social: this.state.user.razon_social,
                    email: this.state.user.email,
                    telefono: this.state.user.telefono,
                    direccion: this.state.user.direccion,
                    ciudad: this.state.user.ciudad,
                    provincia: this.state.user.provincia,
                    cp: this.state.user.cp,
                    cuit: this.state.user.cuit,
                    clave_fiscal: this.state.user.clave_fiscal,
                    cur: this.state.user.cur,
                    inicio_actividad: this.state.user.inicio_actividad,
                    aportes_sipa: this.state.user.aportes_sipa,
                    os: this.state.user.os,
                    familiares_os: this.state.user.familiares_os,
                    cuit_empleador: this.state.user.cuit_empleador,
                    iibb: this.state.user.iibb,
                    iibb_numero: this.state.user.iibb_numero,
                    local_comercial: this.state.user.local_comercial,
                    costo_alquiler: this.state.user.costo_alquiler,
                    actividad_1: this.state.user.actividad_1,
                    actividad_2: this.state.user.actividad_2,
                    actividad_3: this.state.user.actividad_3,
                    estado_usuario: this.state.user.estado_usuario,
                    estado_clave_fiscal: this.state.user.estado_clave_fiscal,
                    estado_monotributo: this.state.user.estado_monotributo,
                    estado_pago: this.state.user.estado_pago,
                    plan: this.state.user.plan,
                    plan_id: this.state.user.plan_id,
                    fecha_inicio: this.state.user.fecha_inicio,
                    fecha_fin: this.state.user.fecha_fin,
                    fac_inicial_sem_actual: this.state.user.fac_inicial_sem_actual,
                    fac_inicial_sem_anterior: this.state.user.fac_inicial_sem_anterior,
                    punto_venta: this.state.user.punto_venta,
                    foto_dni_fr: this.state.user.foto_dni_fr,
                    foto_dni_tr: this.state.user.foto_dni_tr,
                    foto_rostro: this.state.user.foto_rostro,
                    tipo_actividad: this.state.user.tipo_actividad,
                    cat_monotributo: this.state.user.cat_monotributo,
                    tipo_responsable: this.state.user.tipo_responsable,
                    actividad_preliminar: this.state.user.actividad_preliminar,
                    estado_cbu: this.state.user.estado_cbu,
                }
                if(this.state.user.estado_usuario === "BAJA" || this.state.user.estado_monotributo === "HACER_BAJA"){
                    body["baja"]=this.state.user.estado_monotributo === "HACER_BAJA" ? true: false
                }
                API.put(
                    'test',
                    endpoint,
                    {
                        headers: {
                            Authorization: session.getIdToken().getJwtToken()
                        },
                        body: body
                    }
                )
                    .then(response => {
                        message.success("Usuario actualizado")
                        this.setState({ loading: false })
                    })
                    .catch(err => {
                        message.error("Error de actualización de usuario")
                        this.setState({ loading: false })

                    })

            })
            .catch(err => {
                message.error("Error obteniendo credenciales de usuario")
                console.log(err)
            })
    }

    componentDidMount() {
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/taxes/monotributos',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        let monotributos = response.monotributos.map(mono => {
                            mono["key"] = mono["categoria"]
                            return mono
                        })
                        this.setState({ monotributos: monotributos, loading_monotributo: false })
                    })
                    .catch(err => console.log(err))
            })

        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/taxes/iibb',
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        let iibb_all = response.map(ib => {
                            ib["key"] = ib["provincia"] + ib['categoria']
                            return ib
                        })
                        let iibb_filtered = iibb_all.filter(iibb => iibb.provincia === this.state.user.provincia)
                        this.setState({ iibb: iibb_filtered, loading_iibb: false })
                    })
                    .catch(err => console.log(err))
            })

        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/dashboard/' + this.props.user_id,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        this.setState({ dash_data: response['dashboard'], user: response['user'], new_data: response['user'], loading_dashboard: false })
                        if (!(response['user'].plan_id === null || response['user'].plan_id === undefined)) {
                            this.getPaymentMethod(response['user'].plan_id)
                        } else { this.setState({ loading_user: false }) }
                    })
                    .catch(err => {
                        message.error('Error obteniendo indices Dashboard usuario')
                        this.setState({ loading_dashboard: false })
                    })
            })

        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/root/invoices/admin/' + this.props.user_id,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        },
                    }
                )
                    .then(response => {
                        this.setState({ loading_user: false, facturas: response['invoices'] })
                    })
                    .catch(err => {
                        console.log(err)
                        this.setState({ loading: false })
                    })

            })
    }

    getPaymentMethod(planId) {
        Auth.currentSession()
            .then(response => {
                API.get(
                    'test',
                    '/taxes/planes/' + planId,
                    {
                        headers: {
                            Authorization: response.getIdToken().getJwtToken()
                        }
                    }
                )
                    .then(response => {
                        this.setState({ medioPago: response.medio, loading_user: false })
                    })
                    .catch(err => {
                        console.log(err)
                        this.setState({ loading_user: false })
                    })
            })
    }


    async handleView(imgName) {
        try {
            const img = await Storage.get(this.state.user.email.toLowerCase() + '/' + imgName, { download: false })
            window.open(img, '_blank')

        }
        catch (e) {
            console.log(e)
        }


    }

    handleDelete(imgName) {
        Storage.remove(this.state.user.email.toLowerCase() + '/' + imgName)
            .then(result => {
                let newState = { ...this.state.user }
                newState[imgName] = false
                this.setState({ user: newState })
                this.call_api(true)
            })

            .catch(err => console.log(err))

    }


    showModal = () => {
        this.setState({ visible: true })
    };

    handleOk = e => {
        console.log(e);
        this.setState({ visible: false })
    }

    handleCancel = e => {
        console.log(e);
        this.setState({ visible: false })
    }

    upDateState = () => {
        const new_user = this.state.new_data
        this.setState({ user: new_user, editting: false })
        this.call_api(false)
    }

    isEditing = () => {
        this.setState({ editting: true })
    }

    updateData(field, value) {
        const user = { ...this.state.new_data }
        user[field] = value
        this.setState({ new_data: user })
    }

    cancell = () => {
        this.setState({ editting: false });
        this.props.form.resetFields();
    }

    cancellPhotoRequest() {
        let user = { ...this.state.user }
        this.setState({ user: user, visible: false })
        this.call_api(true)
    }

    cancellPhotoRequestAndSendEmail() {
        let user = { ...this.state.user }
        this.setState({ user: user, visible: false })
        //this.send_motivo()
        this.send_data(true);
    }

    checkBoxChange(value) {
        const user = { ...this.state.user }
        if (user[value] === true) {
            user[value] = false
            this.setState({ user: user })
            return;
        }
        else {
            user[value] = true
            this.setState({ user: user })
            return;
        }
    }

    render() {

        const positiveNumberValidator = (rule, value, callback) => {
            if (value > 0) {
                callback()
            }
            else {
                callback("Ingrese un Numero valido")
            }
        }

        const cuitValidator = (rule, value, callback) => {

            if (typeof (value) === 'undefined' || value === null || value === '') {
                callback('CUIT requerido')
            }

            value = value.toString().replace(/\W/g, "");
            if (value === '') {
                callback('CUIT requerido')
            }
            else if (value.length !== 11) {
                callback('El cuit debe tener 11 numeros')
            }
            else {
                var mult = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
                var total = 0;
                for (var i = 0; i < mult.length; i++) {
                    total += parseInt(value[i]) * mult[i];
                }
                var mod = total % 11;
                var digito = mod === 0 ? 0 : mod === 1 ? 9 : 11 - mod;
            }
            if (digito === parseInt(value[10])) {
                callback()

            } else {
                callback('CUIT invalido')
            }
        }


        const { getFieldDecorator } = this.props.form;

        if (this.state.loading_user || this.state.loading_iibb || this.state.loading_monotributo) {
            return <Spin></Spin>
        }
        else if (this.state.invoiceView === false) {
            let acumulacionSemestral = (this.state.dash_data.facturacion_acumulada === undefined || this.state.dash_data.facturacion_acumulada === null) ? 0 : this.state.dash_data.facturacion_acumulada
            let acumSemestralPercent = Math.round((this.state.dash_data.facturacion_acumulada / this.state.dash_data.monotributo_maximo) * 100)
            let disponibleFacturacion = this.state.dash_data.monotributo_maximo - this.state.dash_data.facturacion_acumulada
            let TableDataCuota = [
                { componente: "Cuota actividad", valor: this.state.dash_data.cuota_actividad, key: "cuota_actividad" },
                { componente: "Cuota OS", valor: this.state.dash_data.cuota_os, key: "cuota_os" },
                { componente: "Cuota SIPA", valor: this.state.dash_data.cuota_sipa, key: "cuota_sipa" },
                { componente: "Cuota actividad prox.", valor: this.state.dash_data.cuota_actividad_prox, key: "cuota_actividad_pox" },
                { componente: "Cuota OS prox.", valor: this.state.dash_data.cuota_os_prox, key: "cuota_os_prox" },
                { componente: "Cuota SIPA prox.", valor: this.state.dash_data.cuota_sipa_prox, key: "cuota_sipa_prox" },
            ]
            let TableDataMono = [
                { componente: "Fact. Acumulada", valor: acumulacionSemestral.toLocaleString(), key: "acumulacion_semestral" },
                { componente: "Fact. Acumulada porcent.", valor: (acumSemestralPercent > 100 ? "100" : acumSemestralPercent).toLocaleString(), key: "fac_acumulada_porcent" },
                { componente: "Disponible p/ facturar", valor: (disponibleFacturacion > 0 ? disponibleFacturacion : "0").toLocaleString(), key: "fac_acumulada" },
                { componente: "Deuda c/ AFIP", valor: this.state.user.deuda_afip === null ? 0 : this.state.user.deuda_afip, key: "deuda_afip" },
                { componente: "Proximo Vto.", valor: this.state.dash_data.monotributo_vto, key: "monotributo_vto" },

            ]
            let columns = [
                {
                    title: "Campo",
                    dataIndex: "componente",
                    key: "componente",
                    width: "15%"
                },
                {
                    title: "Valor",
                    dataIndex: 'valor',
                    key: "valor",
                    width: "15%"
                }
            ]

            let columnsFacturas = [
                {
                    title: "Fecha",
                    dataIndex: "fecha",
                    key: "fecha",
                    render: (value, row, index) => {
                        return {
                            children: moment(value).format("YYYY-MM-DD HH:MM")
                        }
                    },
                    sorter: (a, b) => moment(a.fecha).diff(b.fecha),
                    defaultSortOrder: 'descend'
                },
                {
                    title: "N° Comprobante",
                    dataIndex: "nroDeComprobante",
                    key: "nroDeComprobante",
                    sorter: (a, b) => a.nroDeComprobante - b.nroDeComprobante,
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <div style={{ padding: 8 }}>
                            <Input
                                ref={node => {
                                    this.searchInput = node;
                                }}
                                placeholder="Buscar comprobante"
                                value={selectedKeys[0]}
                                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                                onPressEnter={() => confirm()}
                                style={{ width: 188, marginBottom: 8, display: 'block' }}
                            />
                            <Button
                                type="primary"
                                onClick={() => confirm()}
                                icon="search"
                                size="small"
                                style={{ width: 90, marginRight: 8 }}
                            >
                                Buscar
                            </Button>
                            <Button
                                onClick={() => clearFilters()}
                                size="small"
                                style={{ width: 90 }}
                            >
                                Reset
                            </Button>
                        </div>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    onFilter: (value, record) => record.nroDeComprobante.toString().toLowerCase().includes(value.toLowerCase()),
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => this.searchInput.select())
                        }
                    }
                },
                {
                    title: "Tipo",
                    dataIndex: "tipoDeComprobante",
                    key: "tipoDeComprobante",
                    render: (value) => {
                        let text = ""
                        switch (value) {
                            case 11:
                                text = "Factura C"
                                break
                            case 13:
                                text = "Nota de Crédito C"
                                break
                            case 12:
                                text = "Nota de Débito C"
                                break
                            case 15:
                                text = "Recibos C"
                                break
                            default:
                                break
                        }
                        return {
                            children:
                                <Tag>
                                    {text}
                                </Tag>
                        }
                    },
                    filters: [
                        {
                            value: 11,
                            text: "Factura C"
                        },
                        {
                            value: 13,
                            text: "Nota de Crédito C"
                        },
                        {
                            value: 12,
                            text: "Nota de Débito C"
                        },
                        {
                            value: 15,
                            text: "Recibos C"
                        }
                    ],
                    filterMultiple: true,
                    onFilter: (value, record) => record.tipoDeComprobante.toString().indexOf(value) === 0,
                },
                {
                    title: "DNI/CUIT Cliente",
                    dataIndex: "nroDocumento",
                    key: "nroDocumento",
                    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
                        <div style={{ padding: 8 }}>
                            <Input
                                ref={node => {
                                    this.searchInput = node;
                                }}
                                placeholder="Buscar DNI/CUIT Cliente"
                                value={selectedKeys[0]}
                                onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                                onPressEnter={() => confirm()}
                                style={{ width: 188, marginBottom: 8, display: 'block' }}
                            />
                            <Button
                                type="primary"
                                onClick={() => confirm()}
                                icon="search"
                                size="small"
                                style={{ width: 90, marginRight: 8 }}
                            >
                                Buscar
                            </Button>
                            <Button
                                onClick={() => clearFilters()}
                                size="small"
                                style={{ width: 90 }}
                            >
                                Reset
                            </Button>
                        </div>
                    ),
                    filterIcon: filtered => (
                        <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
                    ),
                    onFilter: (value, record) => (record.nroDocumento != null) ? record.nroDocumento.toString().toLowerCase().includes(value.toLowerCase()) : "",
                    onFilterDropdownVisibleChange: visible => {
                        if (visible) {
                            setTimeout(() => this.searchInput.select())
                        }
                    }
                },
                {
                    title: "Razón Social",
                    dataIndex: (this.props.batchId === null || this.props.batchId === undefined) ? "razonSocialCliente" : "razon_social",
                    key: (this.props.batchId === null || this.props.batchId === undefined) ? "razonSocialCliente" : "razon_social"
                },
                {
                    title: "Importe",
                    dataIndex: "importeTotal",
                    key: "importeTotal",
                    sorter: (a, b) => a.importeTotal - b.importeTotal
                },
                {
                    title: "Estado",
                    dataIndex: "estado",
                    key: "estado",
                    render: (value) => {
                        let text = ""
                        switch (value) {
                            case "DRAFT":
                                text = "Borrador"
                                break
                            case "PENDING_AFIP":
                                text = "Pendiente"
                                break
                            case "EMITTED":
                                text = "Emitida"
                                break
                            case "CANCELED":
                                text = "Cancelada"
                                break
                            case "QUEUED":
                                text = "Cola"
                                break
                            case "REJECTED":
                                text = "Rechazada"
                                break
                            default:
                                break;

                        }
                        return {
                            children:
                                <Tag>
                                    {text}
                                </Tag>
                        }
                    }
                },
                {
                    title: "Acciones",
                    dataIndex: "actions",
                    key: "actions",
                    render: (text, record, index) => {
                        return {
                            children: <Button onClick={() => this.getFactura(record.invoiceId)}>
                                Ver
                            </Button>
                        }
                    }
                }

            ]

            return (
                <div>

                    <Card style={{ marginBottom: "10px" }}
                        title={"Datos Personales"}
                    >


                        <Row gutter={[8, 8]}>
                            <Col lg={6}>
                                <Form.Item label="Nombre">{
                                    getFieldDecorator('nombre', {
                                        rules: [{
                                            required: true,
                                            message: 'Nombre requerido'
                                        },
                                        ],
                                        initialValue: this.state.user.nombre,
                                        value: this.state.new_data.nombre
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("nombre", e.target.value ? e.target.value : null)}
                                        />
                                    )
                                }
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Apellido">{
                                    getFieldDecorator('apellido', {
                                        rules: [{
                                            required: true,
                                            message: 'Apellido requerido'
                                        }],
                                        initialValue: this.state.user.apellido,
                                        value: this.state.new_data.apellido
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("apellido", e.target.value ? e.target.value : null)}
                                        />
                                    )
                                }
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Mail">{
                                    getFieldDecorator('email', {
                                        rules: [{
                                            required: true,
                                            message: 'email requerido'
                                        }],
                                        initialValue: this.state.user.email,
                                        value: this.state.new_data.email
                                    })(
                                        <Input
                                            disabled={true}
                                            onChange={(e) => this.updateData("email", e.target.value ? e.target.value : null)}
                                        />
                                    )
                                }
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Telefono">{
                                    getFieldDecorator('telefono', {
                                        rules: [{
                                            required: true,
                                            message: 'Telefono requerido'
                                        }, {
                                            valitador: positiveNumberValidator
                                        }
                                        ],
                                        initialValue: this.state.user.telefono,
                                        value: this.state.new_data.telefono
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("telefono", e.target.value ? e.target.value : null)}
                                        />
                                    )
                                }
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={[8, 8]}>

                            <Col lg={6}>
                                <Form.Item label="Direccion">{
                                    getFieldDecorator('direccion', {
                                        rules: [{
                                            required: true,
                                            message: 'direccion requerido'
                                        }],
                                        initialValue: this.state.user.direccion,
                                        value: this.state.new_data.direccion
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("direccion", e.target.value ? e.target.value : null)}
                                            suffix={
                                                <Tooltip title="Direccion con que te diste de alta en AFIP">
                                                    <Icon type="info-circle" />
                                                </Tooltip>
                                            }
                                        />
                                    )
                                }
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Ciudad">{
                                    getFieldDecorator('ciudad', {
                                        rules: [{
                                            required: true,
                                            message: 'ciudad requerido'
                                        }],
                                        initialValue: this.state.user.ciudad,
                                        value: this.state.new_data.ciudad
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("ciudad", e.target.value ? e.target.value : null)}
                                        />
                                    )
                                }
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Código Postal">{
                                    getFieldDecorator('cp', {
                                        rules: [{
                                            required: true,
                                            message: 'CP requerido'
                                        }, {
                                            validator: positiveNumberValidator
                                        }
                                        ],
                                        initialValue: this.state.user.cp,
                                        value: this.state.new_data.cp
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("cp", e.target.value ? e.target.value : null)}
                                        />
                                    )
                                }
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Provincia">{
                                    getFieldDecorator('provincia', {
                                        rules: [{
                                            required: true,
                                            message: 'Provincia requerida'
                                        }],
                                        initialValue: this.state.user.provincia,
                                        value: this.state.new_data.provincia
                                    })(
                                        <Select
                                            style={{ width: 240 }}
                                            disabled={!this.state.editting}
                                            onChange={(value) => this.updateData("provincia", value)}
                                        >{
                                                definitions.provincia.map(prov => {
                                                    return <Option key={prov.value} value={prov.value}> {prov.name} </Option>
                                                })
                                            }
                                        </Select>)}

                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={[8, 8]} style={{ marginTop: 5, marginBottom: 5 }}>

                            <Col lg={8} style={{ marginTop: 5, marginBottom: 5 }}>
                                <Upload
                                    name='dniAdelante'
                                    method='get'
                                    showUploadList={false}
                                    accept='.png,.jpg'
                                    action={(evt) => this.onChange(evt, 'foto_dni_fr')}
                                    beforeUpload={beforeUpload}
                                >
                                    <Popover placement='bottom' content={<div><p><b>Formato:</b> .jpg o .png</p><p><b>Tamaño Max:</b> 5MB</p></div>}>
                                        <Button disabled={this.state.user.foto_dni_fr} loading={this.state.loadingImage} style={{ width: 320 }}>
                                            Subir foto DNI frente
                                        </Button>
                                    </Popover>
                                </Upload>
                            </Col>

                            <Col lg={8} style={{ marginTop: 5, marginBottom: 5 }}>
                                <Upload
                                    name='dniAtras'
                                    method='get'
                                    showUploadList={false}
                                    accept='.png,.jpg'
                                    action={(evt) => this.onChange(evt, 'foto_dni_tr')}
                                    beforeUpload={beforeUpload}
                                >
                                    <Popover placement='bottom' content={<div><p><b>Formato:</b> .jpg o .png</p><p><b>Tamaño Max:</b> 5MB</p></div>}>
                                        <Button disabled={this.state.user.foto_dni_tr} loading={this.state.loadingImage} style={{ width: 320 }} >
                                            Subir foto DNI Atras
                                        </Button>
                                    </Popover>
                                </Upload>
                            </Col>

                            <Col lg={8} style={{ marginTop: 5, marginBottom: 5 }}>
                                <Upload
                                    name='rostro'
                                    method='get'
                                    showUploadList={false}
                                    accept='.png,.jpg'
                                    action={(evt) => this.onChange(evt, 'foto_rostro')}
                                    beforeUpload={beforeUpload}
                                >
                                    <Popover placement='bottom' content={<div><p><b>Formato:</b> .jpg o .png</p><p><b>Tamaño Max:</b> 5MB</p></div>}>
                                        <Button disabled={this.state.user.foto_rostro} loading={this.state.loadingImage} style={{ width: 320 }}>
                                            Subir foto rostro
                                        </Button>
                                    </Popover>
                                </Upload>
                            </Col>

                        </Row>

                        <Row gutter={[8, 8]}>
                            <Col lg={8}>
                                <Row>
                                    <Button disabled={!this.state.user.foto_dni_fr} type='link' onClick={() => this.handleView('foto_dni_fr')}>
                                        Ver foto DNI frente
                                    </Button>
                                    {/* <Popconfirm disabled={!this.state.user.foto_dni_fr} title="Seguro que desea borrar la foto?" onConfirm={() => this.handleDelete('foto_dni_fr')}>
                                        <a href="#/">Borrar foto DNI frente</a>
                                    </Popconfirm> */}
                                </Row>

                            </Col>
                            <Col lg={8}>
                                <Row>
                                    <Button disabled={!this.state.user.foto_dni_tr} type='link' onClick={() => this.handleView('foto_dni_tr')}>
                                        Ver foto DNI atras
                                    </Button>
                                    {/* <Popconfirm disabled={!this.state.user.foto_dni_tr} title="Seguro que desea borrar la foto?" onConfirm={() => this.handleDelete('foto_dni_tr')}>
                                        <a href="#/">Borrar foto DNI atras</a>
                                    </Popconfirm> */}
                                </Row>

                            </Col>
                            <Col lg={8}>
                                <Row>
                                    <Button disabled={!this.state.user.foto_rostro} type='link' onClick={() => this.handleView('foto_rostro')}>
                                        Ver foto Rostro
                                    </Button>
                                    {/* <Popconfirm disabled={!this.state.user.foto_rostro} title="Seguro que desea borrar la foto?" onConfirm={() => this.handleDelete('foto_rostro')}>
                                        <a href="#/">Borrar foto Rostro</a>
                                    </Popconfirm> */}
                                </Row>

                            </Col>
                        </Row>
                        <Row gutter={[8, 8]}>
                            <Col lg={5}>
                                <Button
                                    disabled={this.state.editting}
                                    icon="close"
                                    onClick={this.cancellPhotoRequest}
                                >Anular solicitud de fotos</Button>
                            </Col>
                            <Col lg={5}>
                                <Button
                                    disabled={this.state.editting}
                                    icon="close"
                                    onClick={this.showModal}
                                >Borrar fotos</Button>
                                <Modal
                                    title={"Seleccionar fotos a anular"}
                                    visible={this.state.visible}
                                    onOk={this.handleOk}
                                    onCancel={this.handleCancel}
                                    footer={[
                                        <Button key="back" onClick={this.handleCancel}>
                                            Cancelar
                                        </Button>,
                                        <Button key="submit" type="primary" onClick={this.cancellPhotoRequest}>
                                            Confirmar eliminación
                                        </Button>,
                                        <Button key="submit1" type="secondary" onClick={this.cancellPhotoRequestAndSendEmail}>
                                            Confirmar y enviar correo
                                        </Button>
                                    ]}
                                    >
                                    <Form.Item>
                                    {
                                        getFieldDecorator('foto_dni_fr', {
                                            valuePropName: 'checked',
                                            defaultChecked: !this.state.user.foto_dni_fr,
                                            initialValue: !this.state.user.foto_dni_fr,
                                            value: this.state.user.foto_dni_fr
                                        })
                                            (<Checkbox onChange={() => this.checkBoxChange("foto_dni_fr")} >Foto DNI frente</Checkbox>)
                                    }
                                    </Form.Item>
                                    <Form.Item>
                                    {
                                        getFieldDecorator('foto_dni_tr', {
                                            valuePropName: 'checked',
                                            defaultChecked: !this.state.user.foto_dni_tr,
                                            initialValue: !this.state.user.foto_dni_tr,
                                            value: this.state.user.foto_dni_tr
                                        })
                                            (<Checkbox onChange={() => this.checkBoxChange("foto_dni_tr")} >Foto DNI atrás</Checkbox>)
                                    }
                                    </Form.Item>
                                    <Form.Item>
                                    {
                                        getFieldDecorator('foto_rostro', {
                                            valuePropName: 'checked',
                                            defaultChecked: !this.state.user.foto_rostro,
                                            initialValue: !this.state.user.foto_rostro,
                                            value: this.state.user.foto_rostro
                                        })
                                            (<Checkbox onChange={() => this.checkBoxChange("foto_rostro")} >Foto rostro</Checkbox>)
                                    }
                                    </Form.Item>
                                    <Form.Item label="Motivo">
                                        <TextArea
                                            value={this.state.motivoAnulacion}
                                            onChange={(e) => this.setState( {motivoAnulacion: e.target.value ? e.target.value : null} )}
                                        />
                                    </Form.Item>
                                </Modal>
                            </Col>
                        </Row>
                    </Card>

                    <Card
                        style={{ marginBottom: "10px" }}
                        title={"Datos Impositivos"}>
                        <Row gutter={[8, 8]}>

                            <Col lg={6}>
                                <Form.Item label="CUIT">{
                                    getFieldDecorator('cuit', {
                                        rules: [{
                                            required: true,
                                            validator: cuitValidator
                                        }],

                                        initialValue: this.state.user.cuit,
                                        value: this.state.new_data.cuit
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("cuit", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Clave Fiscal">{
                                    getFieldDecorator('clave_fiscal', {
                                        rules: [{
                                            required: true,
                                            message: 'Clave fiscal requerido'
                                        }],
                                        initialValue: this.state.user.clave_fiscal,
                                        value: this.state.new_data.clave_fiscal
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("clave_fiscal", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Fact. Inicial Sem. Anterior">{
                                    getFieldDecorator('fac_inicial_sem_anterior', {
                                        initialValue: this.state.user.fac_inicial_sem_anterior,
                                        value: this.state.new_data.fac_inicial_sem_anterior
                                    })(
                                        <InputNumber
                                            style={{ width: 240 }}
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("fac_inicial_sem_anterior", e ? e : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Fact. Inicial Sem. Actual">{
                                    getFieldDecorator('fac_inicial_sem_actual', {
                                        initialValue: this.state.user.fac_inicial_sem_actual,
                                        value: this.state.new_data.fac_inicial_sem_actual
                                    })(
                                        <InputNumber
                                            style={{ width: 240 }}
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("fac_inicial_sem_actual", e ? e : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={[8, 8]}>
                            <Col lg={6}>
                                <Form.Item label="Aportes SIPA">{
                                    getFieldDecorator('aportes_sipa', {
                                        initialValue: this.state.user.aportes_sipa,
                                        value: this.state.new_data.aportes_sipa
                                    })(
                                        <Radio.Group
                                            placeholder="aportes_sipa"
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("aportes_sipa", e.target.value)}
                                        >
                                            <Radio.Button style={{ width: 115 }} value={true}>True</Radio.Button>
                                            <Radio.Button style={{ width: 115 }} value={false}>False</Radio.Button>
                                        </Radio.Group>)}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Pto Venta.">{
                                    getFieldDecorator('puntoVenta', {
                                        initialValue: this.state.user.punto_venta,
                                        value: this.state.new_data.punto_venta
                                    })(
                                        <InputNumber
                                            style={{ width: 240 }}
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("punto_venta", e ? e : null)}
                                            min={0}
                                            max={999999}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Adherentes">{
                                    getFieldDecorator('familiares_os', {
                                        initialValue: this.state.user.familiares_os,
                                        value: this.state.new_data.familiares_os
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("familiares_os", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="CUIT Empleador">{
                                    getFieldDecorator('cuit_empleador', {
                                        initialValue: this.state.user.cuit_empleador,
                                        value: this.state.new_data.cuit_empleador
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("cuit_empleador", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={[8, 8]}>

                            <Col lg={6}>
                                <Form.Item label="Cat. IIBB">{
                                    getFieldDecorator('iibb', {
                                        initialValue: this.state.user.iibb,
                                        value: this.state.new_data.iibb
                                    })(
                                        <Select
                                            placeholder="Categoria IIBB"
                                            style={{ width: 240 }}
                                            disabled={!this.state.editting}
                                            onChange={(value) => this.updateData("iibb", value)}
                                        >
                                            {
                                                this.state.iibb.map(cat => {
                                                    return <Option key={cat.key} value={cat.categoria}>{cat.categoria}</Option>
                                                })
                                            }
                                        </Select>)}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Nro. IIBB">{
                                    getFieldDecorator('iibb_numero', {
                                        initialValue: this.state.user.iibb_numero,
                                        value: this.state.new_data.iibb_numero
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("iibb_numero", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Metros cuadrados">{
                                    getFieldDecorator('local_comercial', {
                                        initialValue: this.state.user.local_comercial,
                                        value: this.state.new_data.local_comercial
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("local_comercial", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Costo Alquiler">{
                                    getFieldDecorator('costo_alquiler', {
                                        initialValue: this.state.user.costo_alquiler,
                                        value: this.state.new_data.costo_alquiler
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("costo_alquiler", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={[8, 8]}>
                            <Col lg={6}>
                                <Form.Item label="Tipo de Actividad">{
                                    getFieldDecorator('tipo_actividad', {
                                        initialValue: this.state.user.tipo_actividad,
                                        value: this.state.new_data.tipo_actividad
                                    })(
                                        <Select
                                            placeholder="Actividades"
                                            style={{ width: 240 }}
                                            disabled={!this.state.editting}
                                            onChange={(value) => this.updateData("tipo_actividad", value)}
                                        >
                                            <Option value="presta_servicios">Prestación de Servicios</Option>
                                            <Option value="vende_mercaderia">Venta de cosas Muebles </Option>
                                            <Option value="alquileres">Alquila inmuebles y/o máquinas</Option>
                                        </Select>)}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Actividad a desarrollar 1">{
                                    getFieldDecorator('actividad_11', {
                                        initialValue: this.state.user.actividad_1,
                                        value: this.state.new_data.actividad_1
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("actividad_1", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Actividad a desarrollar 2">{
                                    getFieldDecorator('actividad_2', {
                                        initialValue: this.state.user.actividad_2,
                                        value: this.state.new_data.actividad_2
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("actividad_2", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Actividad a desarrollar 3">{
                                    getFieldDecorator('actividad_3', {
                                        initialValue: this.state.user.actividad_3,
                                        value: this.state.new_data.actividad_3
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("actividad_3", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                        </Row>
                        <Row gutter={[8, 8]}>
                            <Col lg={6}>
                                <Form.Item label="Fecha Inicio Actividad">{
                                    getFieldDecorator('inicio_actividad', {
                                        initialValue: this.state.user.inicio_actividad,
                                        value: this.state.new_data.inicio_actividad,

                                    })(
                                        <Input
                                            placeholder={'YYYY-MM-DD'}
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("inicio_actividad", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="CBU">{
                                    getFieldDecorator('cbu', {
                                        initialValue: this.state.user.cbu,
                                        value: this.state.new_data.cbu
                                    })(
                                        <Input
                                            style={{ width: 240 }}
                                            disabled={true}
                                            onChange={(e) => this.updateData("cbu", e ? e : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="VEP">{
                                    getFieldDecorator('vep', {
                                        initialValue: this.state.user.vep,
                                        value: this.state.new_data.vep
                                    })(
                                        <Input
                                            style={{ width: 240 }}
                                            disabled={true}
                                            onChange={(e) => this.updateData("vep", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Cat. Monotributo">{
                                    getFieldDecorator('cat_monotributo', {
                                        rules: [{
                                            required: true,
                                            message: 'Dato Requerido'
                                        }],
                                        initialValue: this.state.user.cat_monotributo,
                                        value: this.state.new_data.cat_monotributo
                                    })(
                                        <Select
                                            placeholder="Actividades"
                                            style={{ width: 240 }}
                                            disabled={!this.state.editting}
                                            onChange={(value) => this.updateData("cat_monotributo", value)}
                                        >
                                            {
                                                this.state.monotributos.map(cat => {
                                                    return <Option key={cat.key} value={cat.categoria}>{cat.categoria}</Option>
                                                })
                                            }
                                        </Select>)}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Tipo de responsable">{
                                    getFieldDecorator('tipo_responsable', {
                                        rules: [{ required: true, message: 'Campo requerido' }],
                                        initialValue: this.state.user.tipo_responsable,
                                        value: this.state.new_data.tipo_responsable
                                    })(
                                        <Select
                                            placeholder="Actividades"
                                            style={{ width: 240 }}
                                            disabled={!this.state.editting}
                                            onChange={(value) => this.updateData("tipo_responsable", value)}
                                        >
                                            <Option value="Responsable Monotributo">Responsable Monotributo</Option>
                                            <Option value="Monotributista Social">Monotributista Social </Option>
                                        </Select>)}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="CUR">{
                                    getFieldDecorator('cur', {
                                        initialValue: this.state.user.cur,
                                        value: this.state.new_data.cur
                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("cur", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Razon Social">{
                                    getFieldDecorator('razon_social', {
                                        rules: [{
                                            required: true,
                                            message: 'Razon social requerida'
                                        }],
                                        initialValue: this.state.user.razon_social,
                                        value: this.state.new_data.razon_social

                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("razon_social", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Trabaja en">{
                                    getFieldDecorator('trabaja_en', {
                                        initialValue: this.state.user.employment_relationship && this.state.user.employment_relationship[0] && this.state.user.employment_relationship[0].razonSocial,
                                        value: this.state.user.employment_relationship.razon_social,
                                    })(
                                        <Input
                                            disabled={true}
                                            onChange={(e) => this.updateData("trabaja_en", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                        </Row>

                        <Row gutter={[8, 8]}>
                            <Col lg={6}>
                                <Form.Item label="Actividad preliminar">{
                                    getFieldDecorator('actividad_preliminar', {
                                        initialValue: this.state.user.actividad_preliminar,
                                        value: this.state.new_data.actividad_preliminar,

                                    })(
                                        <Input
                                            placeholder={'Actividad preliminar'}
                                            disabled={!this.state.editting}
                                            onChange={(e) => this.updateData("actividad_preliminar", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            
                            <Col lg={6}>
                                <Form.Item label = "Estado CBU">{
                                    getFieldDecorator('estado:cbu' ,{
                                        initialValue: this.state.user.estado_cbu,
                                        value: this.state.new_data.estado_cbu,
                                    })(

                                        <Select
                                            placeholder="Estado CBU"
                                            style={{ width: 240 }}
                                            disabled={!this.state.editting || (true ? this.state.user.estado_cbu == "ADHERIDO" : false)}
                                            onChange={(value) => this.updateData("estado_cbu", value)}
                                        >
                                            <Option value="POR_ADHERIR">Por adherir</Option>
                                            <Option value="ADHERIDO">Adherido </Option>
                                        </Select>
                                    )
                                }

                                </Form.Item>
                            </Col>
                            </Row>  

                    </Card>

                    <Card style={{ marginBottom: "10px" }}
                        title={"Datos Liqui"}>

                        <Row gutter={[8, 8]}>

                            <Col lg={6}>
                                <Form.Item label="Tu plan">{
                                    getFieldDecorator('plan', {
                                        initialValue: this.state.user.plan,
                                        value: this.state.new_data.plan
                                    })(
                                        <Select
                                            disabled={!this.state.editting}
                                            style={{ width: 240 }}
                                            onChange={(value) => {
                                                this.updateData("plan", value)
                                            }}
                                        >

                                            <Option value='Aplicaciones'>Aplicaciones</Option>
                                            <Option value='Plus'>Plus</Option>
                                            <Option value='Premium'>Premium</Option>


                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Medio de Pago">{
                                    getFieldDecorator('medioPagp', {
                                        initialValue: this.state.medioPago,
                                        value: this.state.medioPago
                                    })(
                                        <Input
                                            style={{ width: 240 }}
                                            onChange={(value) => {
                                                this.updateData("medioPago", value)
                                            }}
                                            disabled={true}
                                        >


                                        </Input>
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Fecha de inicio de plan">{
                                    getFieldDecorator('fecha_inicio', {
                                        initialValue: this.state.user.fecha_inicio,
                                        value: this.state.new_data.fecha_inicio,

                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            placeholder={'YYYY-MM-DD'}
                                            onChange={(e) => this.updateData("fecha_inicio", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                            <Col lg={6}>
                                <Form.Item label="Fecha de fin">{
                                    getFieldDecorator('fecha_fin', {
                                        initialValue: this.state.user.fecha_fin,
                                        value: this.state.new_data.fecha_fin,

                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            placeholder={'YYYY-MM-DD'}
                                            onChange={(e) => this.updateData("fecha_fin", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>

                        </Row>
                        <Row gutter={[8, 8]}>
                            <Col lg={6}>
                                <Form.Item label="Estado Plataforma">{
                                    getFieldDecorator('estado', {
                                        initialValue: this.state.user.estado_usuario,
                                        value: this.state.new_data.estado_usuario
                                    })(
                                        <Select
                                            style={{ width: 240 }}
                                            onChange={(value) => {
                                                this.updateData("estado_usuario", value)
                                            }}
                                            disabled={!this.state.editting}
                                        >{
                                                userStates.estado_usuario.map(estado => {
                                                    return <Option key={estado.value} value={estado.value}>{estado.name}</Option>
                                                })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Estado Monotributo">{
                                    getFieldDecorator('estado_monotributo', {
                                        initialValue: this.state.user.estado_monotributo,
                                        value: this.state.new_data.estado_monotributo
                                    })(
                                        <Select
                                            style={{ width: 240 }}
                                            onChange={(value) => {
                                                this.updateData("estado_monotributo", value)
                                            }}
                                            disabled={!this.state.editting}
                                        >{
                                                userStates.estado_monotributo.map(estado => {
                                                    return <Option key={estado.value} value={estado.value}>{estado.name}</Option>
                                                })
                                            }

                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Estado Clave fiscal">{
                                    getFieldDecorator('estado_clave_fiscal', {
                                        initialValue: this.state.user.estado_clave_fiscal,
                                        value: this.state.new_data.estado_clave_fiscal
                                    })(
                                        <Select
                                            style={{ width: 240 }}
                                            onChange={(value) => {
                                                this.updateData("estado_clave_fiscal", value)
                                            }}
                                            disabled={!this.state.editting}
                                        >{
                                                userStates.estado_clave_fiscal.map(estado => {
                                                    return <Option key={estado.value} value={estado.value}>{estado.name}</Option>
                                                })
                                            }

                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>

                            <Col lg={6}>
                                <Form.Item label="Estado pago">{
                                    getFieldDecorator('estado_pago', {
                                        initialValue: this.state.user.estado_pago,
                                        value: this.state.new_data.estado_pago
                                    })(
                                        <Select
                                            style={{ width: 240 }}
                                            onChange={(value) => {
                                                this.updateData("estado_pago", value)
                                            }}
                                            disabled={!this.state.editting}
                                        >
                                            {
                                                userStates.estado_pago.map(estado => {
                                                    return <Option key={estado.value} value={estado.value}>{estado.name}</Option>
                                                })
                                            }
                                        </Select>
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={[8, 8]}>
                            <Col lg={6}>
                                <Form.Item label="Fecha de baja">{
                                    getFieldDecorator('fecha_baja', {
                                        initialValue: this.state.user.fecha_baja,
                                        value: this.state.new_data.fecha_baja,

                                    })(
                                        <Input
                                            disabled={!this.state.editting}
                                            placeholder={'YYYY-MM-DD'}
                                            onChange={(e) => this.updateData("fecha_baja", e.target.value ? e.target.value : null)}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Card>
                    <Row gutter={[8, 8]}>
                        <Col lg={12}>
                            <Card style={{ marginBottom: '10px' }}
                                title={"Indicadores Dashboard - Cuota"}>
                                <Table
                                    columns={columns}
                                    pagination={false}
                                    dataSource={TableDataCuota}
                                    loading={this.state.loading_dashboard}
                                    scroll={{ x: "max-content" }}
                                />
                            </Card>
                        </Col>
                        <Col lg={12}>
                            <Card style={{ marginBottom: '10px' }}
                                title={"Indicadores Dashboard - Facturacion"}>
                                <Table
                                    columns={columns}
                                    pagination={false}
                                    dataSource={TableDataMono}
                                    loading={this.state.loading_dashboard}
                                    scroll={{ x: "max-content" }}
                                />
                            </Card>

                        </Col>
                    </Row>
                    <Card style={{ marginBottom: '10px' }}
                        title={"Facturas Usuario"}>
                        <Row gutter={[8, 8]}>
                            <Col lg={24}>
                                <Table
                                    columns={columnsFacturas}
                                    dataSource={this.state.facturas}
                                    loading={this.state.loading_user}
                                    scroll={{ x: "max-content" }}
                                />
                            </Col>
                        </Row>
                    </Card>
                    <>
                        <Button
                            style={{ marginBotton: '10px', marginLeft: '5px', marginTop: '5px' }}
                            type={"primary"}
                            disabled={this.state.editting}
                            icon="edit"
                            onClick={this.isEditing}
                        >Editar</Button>

                        <Button
                            style={{ marginBotton: '10px', marginLeft: '5px', marginTop: '5px' }}
                            type={"primary"}
                            icon="save"
                            disabled={!this.state.editting}
                            onClick={this.upDateState}
                        >Guardar</Button>

                        <Button
                            style={{ marginBotton: '10px', marginLeft: '5px', marginTop: '5px' }}
                            disabled={!this.state.editting}
                            icon="close"
                            onClick={this.cancell}
                        >Cancelar</Button>

                        {/*} <Button
                        margin={"10px"}
                        onClick={this.showModal}
                        icon="deleteuser"
                        >Eliminar usuario
                        </Button>
                        <Modal
                        title={"Eliminar usuario"}
                        visible={this.state.visible}
                        onOk={this.handleOk}
                        onCancel={this.handleCancel}
                        footer={[
                            <Button key="back" onClick={this.handleCancel}>
                                Cancelar
                            </Button>,
                            <Button key="submit" type="primary" onClick={this.baja_liqui}>
                                Confirmar eliminacion
                            </Button>,

                        ]}
                        >
                        <p>Seguro que desea eliminar el usuario? </p>
                        <p>Esta accion no se puede deshacer </p>



                    </Modal>*/}
                    </>

                </div>
            )
        }
        else if (this.state.invoiceView) {
            return (
                <div>
                    <InvoiceView factura={this.state.factura} items={this.state.invoiceItems} hideButtons={true}></InvoiceView>
                    <Button onClick={() => this.setState({ invoiceView: false })} >Volver </Button>
                    &nbsp;
                    <Button onClick={() => this.downloadPdf(this.state.factura, this.state.user, this.props.user_id)} >Descargar factura </Button>
                </div>
            )
        }
    }

}
const EditUserComponent = Form.create({ name: 'editUserForm' })(EditUserForm);
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(EditUserComponent));
